// This file is autogenerated from /frontend/sail-next/packages/docs/src/markdoc/demo/switch/Controlled.story.tsx with go/sail-next-tailor-docs-publisher 

import * as React from 'react';
import { Switch } from '@sail/ui';
export const Controlled = () => {
  const [checked, setChecked] = React.useState(false);
  return <Switch onChange={() => {
    setChecked(!checked);
  }} checked={checked} label="This Switch is controlled." />;
};